import lodash from 'lodash';
import { grey, red } from '@mui/material/colors';
import { createTheme } from '@mui/material/styles';

export const PRIMARY_COLOR = '#025578';
export const DARK_GREY = '#7e8a9a';
const LINK_COLOR = '#0071a0';
const BACKGROUND_COLOR = grey[50];

const buildListItemButtonLinkVariantBaseProps = (extendedStylesProps = {}) => ({
  props: { variant: "link" },
  style: {
    textDecoration: "none",
    color: LINK_COLOR,
    ...extendedStylesProps,
  }
});

// A custom theme for this app
const theme = createTheme({
  palette: {
    primary: {
      main: LINK_COLOR,
      contrastText: '#fff'
    },
    secondary: {
      main: '#b0ecff',
      dark: '#7cdbf9',
      contrastText: '#005478'
    },
    error: {
      main: red.A400,
    },
    background: {
      default: BACKGROUND_COLOR,
    },
  },
  typography: {
    h1: {
      fontWeight: 300
    },
    h2: {
      fontWeight: 300
    },
    h3: {
      fontWeight: 300
    },
    h4: {
      fontWeight: 300
    },
    h5: {
      fontWeight: 300
    },
    h6: {
      fontWeight: 300
    }
  },
  components: {
    MuiCssBaseline: {
      '@global': {
        ':root': {
          // Default header height fallback; AppBar updates this at runtime.
          '--app-header-offset': '65px',
        },
        html: {
          backgroundColor: BACKGROUND_COLOR,
          scrollPaddingTop: '80px',
        },
      },
    },
    MuiButton: {
      defaultProps: {
        disableElevation: true,
      },
      styleOverrides: {
        root: {
          textTransform: 'none',
          '&[disabled], &.Mui-disabled': {
            color: 'rgba(0, 0, 0, 0.6)',
            pointerEvents: 'none',
          },
        }
      }
    },
    MuiLink: {
      styleOverrides: {
        root: {
          textDecoration: "none",
          '&[disabled], &.Mui-disabled': {
            color: 'rgba(0, 0, 0, 0.6)',
            pointerEvents: 'none',
          },
        }
      }
    },
    MuiListItemButton: {
      styleOverrides: {
        root: {
          variants: [
            buildListItemButtonLinkVariantBaseProps(),
          ]
        }
      }
    }
  }
});

export const withLinksUnderlined = (theme) => {
  const newTheme = lodash.cloneDeep(theme);
  const underlineStyles = {
    textDecoration: "underline",
    '&:hover': {
      textDecoration: "underline",
    }
  };

  newTheme.components.MuiLink.styleOverrides.root = {
    ...newTheme.components.MuiLink.styleOverrides.root,
    ...underlineStyles
  };

  newTheme.components.MuiButton.styleOverrides.text = {
    ...newTheme.components.MuiButton.styleOverrides.text,
    ...underlineStyles
  };

  newTheme.components.MuiListItemButton.styleOverrides.root = {
    ...newTheme.components.MuiListItemButton.styleOverrides.root,
    variants: [
      buildListItemButtonLinkVariantBaseProps({
        '& .MuiListItemText-primary': {...underlineStyles } }),
    ],
  };

  return newTheme;
};

export default theme;
